var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SecondaryText, Title } from "../../designSystem";
import useLoadingText from "../../hooks/useLoadingText";
import { getAssetDisplay } from "../../utils/asset";
import { formatAmountCapacity } from "../../utils/math";
import ProgressBar from "./ProgressBar";
var CapBar = function (_a) {
    var loading = _a.loading, current = _a.current, cap = _a.cap, _b = _a.copies, copies = _b === void 0 ? { current: "Total Deposits", cap: "Limit" } : _b, _c = _a.displayData, _d = _c === void 0 ? {} : _c, displayCurrent = _d.current, displayCap = _d.cap, _e = _a.labelConfig, labelConfig = _e === void 0 ? { fontSize: 16 } : _e, _f = _a.statsConfig, statsConfig = _f === void 0 ? { fontSize: 16 } : _f, _g = _a.barConfig, barConfig = _g === void 0 ? { height: 4, extraClassNames: "my-3", radius: 2 } : _g, asset = _a.asset;
    var loadingText = useLoadingText();
    console.log("current: ", current, "cap:", cap);
    var percent = cap > 0 ? current / cap : 0;
    if (percent < 0) {
        percent = 0;
    }
    else if (percent > 1) {
        percent = 1;
    }
    percent *= 100;
    // let percent = 0;
    current = current > cap ? cap : current;
    return (_jsxs("div", __assign({ className: "w-100" }, { children: [_jsxs("div", __assign({ className: "d-flex flex-row justify-content-between" }, { children: [_jsx(SecondaryText, __assign({ color: "#FFFFFF", fontSize: labelConfig.fontSize }, { children: copies.cap }), void 0), _jsxs("div", { children: [_jsx(Title, __assign({ className: "mr-2", fontSize: statsConfig.fontSize, lineHeight: 20, color: "rgba(255, 255, 255, 0.8)" }, { children: loading
                                    ? loadingText
                                    : "" + (displayCurrent
                                        ? displayCurrent
                                        : isNaN(Number(current) / Number(cap))
                                            ? ''
                                            : Math.round(Number(current) / Number(cap) * 10000) / 100 + "%") }), void 0), _jsx(Title, __assign({ fontSize: statsConfig.fontSize, lineHeight: 20, fontWeight: 700 }, { children: loading
                                    ? loadingText
                                    : "" + (displayCap
                                        ? displayCap
                                        : formatAmountCapacity(cap) + " " + (asset ? getAssetDisplay(asset) : "")) }), void 0)] }, void 0)] }), void 0), _jsx(ProgressBar, { percent: percent, config: barConfig }, void 0)] }), void 0));
};
export default CapBar;
//# sourceMappingURL=CapBarRTL.js.map